import { render, staticRenderFns } from "./TableView.vue?vue&type=template&id=b0a6a430&scoped=true&"
import script from "./TableView.vue?vue&type=script&lang=js&"
export * from "./TableView.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/all-admin.css?vue&type=style&index=0&id=b0a6a430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a6a430",
  null
  
)

export default component.exports